import AOS from 'aos';

document.addEventListener('DOMContentLoaded', function () {


  // countdown
  function CountDownTimer(el) {
    // read date string and convert to a proper Date object (24-hour format)
    const dateStr = el.dataset.countdownStart.replace(' ', 'T'); // e.g. "2025-12-13T10:00:00"
    const end = new Date(dateStr);

    const _second = 1000,
      _minute = _second * 60,
      _hour = _minute * 60,
      _day = _hour * 24;

    let timer;

    function showRemaining() {
      const now = new Date();
      const distance = end.getTime() - now.getTime();

      if (distance < 0) {
        clearInterval(timer);
        el.innerHTML = el.dataset.countdownEnd || 'End!';
        return;
      }

      const days = Math.floor(distance / _day);
      const hours = Math.floor((distance % _day) / _hour);
      const minutes = Math.floor((distance % _hour) / _minute);
      const seconds = Math.floor((distance % _minute) / _second);

      el.innerHTML = `
        <div class="site-countdown-timer__col">${days}</div> <div class="site-countdown-timer__sep">:</div>
        <div class="site-countdown-timer__col">${hours.toString().padStart(2, '0')}</div> <div class="site-countdown-timer__sep">:</div>
        <div class="site-countdown-timer__col">${minutes.toString().padStart(2, '0')}</div> <div class="site-countdown-timer__sep">:</div>
        <div class="site-countdown-timer__col">${seconds.toString().padStart(2, '0')}</div>
      `;
    }

    showRemaining();
    timer = setInterval(showRemaining, 1000);
  }

  document.querySelectorAll('[data-countdown-start]').forEach(CountDownTimer);


  // animation
  AOS.init({
    once: true
  });


  // modal
  const modalSelector = '.js-modal';
  const modalWrapSelector = '.js-modal-wrap';
  const modalOpenSelector = '.js-modal-link';
  const modalCloseSelector = 'js-modal-close';

  // modal ready
  const modalHTML = `
      <div class="modal js-modal" role="dialog" aria-labelledby="js-modal-title" aria-modal="true" tabindex="-1" id="modal">
        <div class="modal__bg">
          <div class="modal__hold js-modal-wrap"></div>
        </div>
      </div>
    `;
  document.body.insertAdjacentHTML('beforeend', modalHTML);

  // get scrollbar width
  const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;

  // modal open
  function openModal(url) {
    fetch(url)
      .then(response => response.text())
      .then(data => {
        const modal = document.querySelector(modalSelector);
        const modalWrap = modal.querySelector(modalWrapSelector);

        modal.classList.add('open');
        modalWrap.innerHTML = data;

        // execute scripts in fetched HTML
        modalWrap.querySelectorAll('script').forEach(script => {
          const newScript = document.createElement('script');
          if (script.src) newScript.src = script.src;
          else newScript.innerHTML = script.innerHTML;
          document.head.appendChild(newScript).parentNode.removeChild(newScript);
        });

        modal.addEventListener('transitionend', function () {
          modal.focus();
        }, { once: true });

        document.body.classList.add('no-scroll-modal');
        document.body.style.paddingRight = `${scrollbarWidth}px`;
      })
      .catch(() => alert('Fail!'));
  }

  document.addEventListener('click', function (e) {
    const link = e.target.closest(modalOpenSelector);
    if (!link) return;

    e.preventDefault();
    openModal(link.href);
  });

  // modal close
  const modalCloseFunction = function () {
    const modal = document.querySelector(modalSelector);
    const modalWrap = modal.querySelector(modalWrapSelector);

    modal.classList.remove('open');

    modal.addEventListener('transitionend', function () {
      modalWrap.innerHTML = '';
      document.body.classList.remove('no-scroll-modal');
      document.body.style.paddingRight = '0';
    }, { once: true });
  };

  document.addEventListener('click', function (e) {
    if (e.target.classList.contains(modalCloseSelector)) {
      modalCloseFunction();
      e.preventDefault();
    }
  });

  // focus trap
  document.addEventListener('keydown', function (e) {
    const modal = document.querySelector(modalSelector);

    if (!modal.classList.contains('open')) return;
    if (e.key !== 'Tab') return;

    const focusableSelectors = ['a[href]', 'button:not([disabled])', 'input:not([disabled])', 'select:not([disabled])', 'textarea:not([disabled])', '[tabindex]:not([tabindex="-1"])'];
    const focusable = modal.querySelectorAll(focusableSelectors.join(','));

    if (!focusable.length) return;

    const firstEl = focusable[0];
    const lastEl = focusable[focusable.length - 1];

    if (e.shiftKey) {
      if (document.activeElement === firstEl) {
        e.preventDefault();
        lastEl.focus();
      }
    } else {
      if (document.activeElement === lastEl) {
        e.preventDefault();
        firstEl.focus();
      }
    }
  });

  window.addEventListener('load', function () {
    if (sessionStorage.getItem('confirmationModalConfirmed')) return;
    setTimeout(function () {
      const modal = document.querySelector('.js-modal');
      if (!modal.classList.contains('open')) {
        openModal('modal-confirmation.html');
      }
    }, 600);
  });

  document.addEventListener('click', function (e) {
    const confirmBtn = e.target.closest('.js-modal-confirm');
    if (!confirmBtn) return;
    sessionStorage.setItem('confirmationModalConfirmed', 'true');
    modalCloseFunction();
  });


  // subscribe form
  if (document.querySelectorAll('.js-form-subscribe').length) {
    document.getElementById("subscribeForm").addEventListener("submit", function (e) {
      e.preventDefault();

      const form = this;
      const formData = new FormData(form);
      const message = document.getElementById("formMessage");
      const button = form.querySelector(".js-form-subscribe-btn");

      button.disabled = true;
      message.textContent = "Sending...";

      fetch("subscribe.php", {
          method: "POST",
          body: formData
        })
        .then(response => response.json())
        .then(data => {
          message.textContent = data.message;
          message.classList.remove("success", "error");
          message.classList.add(data.success ? "success" : "error");
          if (data.success) {
            form.reset();
          }
        })
        .catch(() => {
          message.textContent = "Something went wrong. Please try again.";
          message.style.color = "red";
        })
        .finally(() => {
          button.disabled = false;
        });
    });
  }


});